module.exports = __webpack_public_path__ + "assets/img/tab-cover1-e8001e78.jpg";